import {profSpac} from 'constants/url';
import useDelete from '../../../components/hooks/useDelete';
import {DeletingOptions} from '../../../components/grid-dx/types';

function useDeleteProfSpac() {
  const deleteProfSpac = useDelete(profSpac);
  return (deletingOptions: DeletingOptions) => deleteProfSpac(deletingOptions);
}

export default useDeleteProfSpac;
